<script setup lang="ts">
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogClose, DialogTrigger } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
</script>

<template>
    <Dialog class="block md:hidden">
        <DialogTrigger as-child>
            <slot name="trigger" />
        </DialogTrigger>
        <DialogContent class="ys-modal-dialog w-full">
            <DialogHeader class="px-4 py-5 mb-6">
                <p class="mb-1 text-center uppercase text-[13px] tracking-widest">{{ $t('Filter') }}</p>
                <DialogClose class="absolute top-4 ltr:right-4 rtl:left-4">
                    <Icon name="ri:close-line" size="20px" class="text-gray-500 translate-all hover:text-gray-700"/>
                </DialogClose>
            </DialogHeader>
            <slot />
            <DialogFooter>
                <DialogClose as-child>
                    <div class="px-5 py-5">
                        <Button variant="primary" size="lg" class="w-full">{{$t('Apply')}}</Button>
                    </div>
                </DialogClose>

            </DialogFooter>


        </DialogContent>
    </Dialog>
</template>

<style scoped lang="scss">

</style>